export default (state, action) => {
  return Object.assign({}, state, action.customer);
};
